module.exports = __webpack_public_path__ + "static/media/AttendanceData.c45a5148.xlsx";